import { c as _c } from "react/compiler-runtime";
import { FiMic } from "react-icons/fi";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import Button from "@/components/ui/button";
import { useMicrophoneController } from "@/hooks/use-audio-devices";
import { cx } from "@/lib/tailwind-utils";
import { useScribeStore } from "@/stores/scribe-store";
export const MicPermissionWarning = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    audioDevices,
    micPermissionGranted,
    requestMicPermission
  } = useMicrophoneController();
  const audioSource = useScribeStore(_temp);
  if (audioSource === "telehealth") {
    return null;
  }
  let t1;
  if ($[0] !== audioDevices || $[1] !== className || $[2] !== micPermissionGranted || $[3] !== requestMicPermission) {
    t1 = !micPermissionGranted ? <Alert variant="error" className={cx("my-4", className)} icon={FiMic}><AlertTitle>Microphone access required</AlertTitle><AlertDescription><div className="mb-2"><span>Please grant microphone access to use this feature</span></div><Button variant="secondary" className="border-red-700 px-2 py-1 text-red-700 hover:bg-red-100" onClick={requestMicPermission}>Request microphone access</Button><div className="mt-3 text-caption"><span className="text-body">If you previously denied access:</span><ul className="mt-1 list-disc pl-2"><li>Chrome/Edge: Click the padlock/camera icon in the address bar and reset permission</li><li>Firefox: Click the padlock in the address bar and change microphone permission</li><li>{"Safari: Go to Safari > Settings for this website > Microphone"}</li></ul></div></AlertDescription></Alert> : audioDevices.length === 0 && <Alert variant="error" className="my-4" icon={FiMic}><AlertTitle>No microphones detected</AlertTitle><AlertDescription><p>We couldn't detect any microphones connected to your device. Please check your microphone connection and refresh the page, or connect a microphone to continue.</p></AlertDescription></Alert>;
    $[0] = audioDevices;
    $[1] = className;
    $[2] = micPermissionGranted;
    $[3] = requestMicPermission;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(s) {
  return s.audioSource;
}